import {matchPath} from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import {publicRoutePaths} from '../routes';
import config from 'utils/config';
import {userStore, LAST_SIGN_IN_METHOD} from 'utils/store';
import {getSessionToken} from 'utils/track';
import {navigate} from '../router';
import {redirectToLogin} from 'utils/auth/getLogoutPath';

function handleApiError(resp) {
	// Assign the status to the body
	const {status} = resp;

	if (status === 400) {
		if (resp?.action === 'refresh') {
			// TODO add a message to the user first could be nice
			location.reload();
		} else {
			return resp;
		}
	} else if (status === 404 && resp?.error === 'Accessible elsewhere') {
		const searchParams = queryparse(window.location.search);
		navigate(`/home?asset=${searchParams.asset}`, {
			state: {wasRedirected: true},
		});
	} else if (status === 401 || status === 403) {
		if (resp.code === 'NO_ACCESS_TO_CONTENT') {
			// Let HubErrorBoundary catch this
			return resp;
		}

		const {pathname, search, hash} = window.location;

		// If we're on a private route, redirect to login
		if (!publicRoutePaths.some(path => matchPath(path, pathname))) {
			const method = search.match(/[&?]login=([\w.-]+)(\b|$)/)?.[1];

			let id = config.federatedLogins?.find(
				({identity}) => identity === method
			)?.id;

			// If method is generic, but there is just one sso login, use it...
			if (
				!id &&
				method === 'sso' &&
				config.federatedLogins?.length === 1
			) {
				id = config.federatedLogins[0].id;
			}

			if (
				// If the search includes automatic login...
				method &&
				// Hub should be active
				config.status === 'active' &&
				// Should have found 1 login
				id
			) {
				// Save this as the preferred option
				userStore({[LAST_SIGN_IN_METHOD]: method});

				// Continue on to Identity provider
				window.location.href = `/auth/federation/${id}/login?RelayState=${btoa(
					JSON.stringify({
						sessionToken: getSessionToken(),
						redirectAfterLogin: `${pathname}${search}`,
					})
				)}${hash}`;
			} else {
				// Load the login page
				redirectToLogin();
			}
		} else {
			// If the route is /login or another public route,
			// which has a different 401 catch, maybe improve and fire an event
			return resp;
		}
	} else {
		return resp;
	}
}

export default handleApiError;
